const checkList = document.getElementById("checkList");
const toStep_one = document.getElementById("toStep_one");
document.addEventListener("DOMContentLoaded", function () {
  const btns = document.querySelectorAll(".select-method-box");
  btns.forEach((btn) => {
    btn.addEventListener("click", function () {
      btns.forEach((btn) => btn.classList.remove("active"));
      this.classList.add("active");
      if (this.id === "checkList") {
        this.classList.add("loading");
        urlParams = new URLSearchParams(window.location.search);
        const lineId =
          urlParams.get("lineId") || sessionStorage.getItem("lineId") || "";
        if (lineId) {
          getUserCard(lineId)
            .then((list) => {
              renderList(list);
            })
            .catch((e) => {
              Message.error(e, 1200);
            })
            .finally(() => {
              this.classList.remove("loading");
            });
        } else {
          setTimeout(() => {
            this.classList.remove("loading");
            ToastNoLineId()
          }, 800);
        }
      } else {
        const stepWizard = document.querySelector("step-wizard");
        if (stepWizard) {
          stepWizard.activateStep(2);
        }
      }
    });
  });
  const backSelect = document.getElementById("back-select");
  backSelect.addEventListener("click", () => {
    const choice = document.querySelector('.select-method');
    const wrapper = document.querySelector('.list-wrapper-user');
    const listWrapper = document.querySelector('.user-card-list');
    if (!choice || !wrapper || !listWrapper) return;
    choice.classList.remove('hide');
    wrapper.classList.add('hide');
  });
});

function getUserCard(lineId) {
  return fetch(
    `https://shopifyrecharge.desim.tech/cms-api/open/lineController/getESIMListByEmailAndUserId?userId=${lineId}`
  )
    .then((response) => response.json())
    .then((data) => {
      if (data.code === 200) {
        console.log(444)
        const esimList = data.data
          .filter(item => item.esimStatus !== "2")
          .map((it) => {
            return {
              cover: it.productImage,
              name: it.productShortName || it.productName,
              expireDate: it.expirationTime,
              coverage: it.country,
              ...it,
              esimStatus: !it.activationCode ? "4" : it.esimStatus,
              disabled: !it.activationCode || it.esimStatus === "0" || it.esimStatus === "4" || !(it.joyRsp === 3 || it.joyRsp === 2)
            };
          })
          .reverse();
        return esimList;
      } else {
        throw new Error(data.msg || "Error");
      }
    })
    .catch((error) => {
      console.error("getUserCard error:", error);
      throw error;
    });
}

const CardArrow = `
<svg width="24px" height="24px" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
      d="M13.9707 18.5297C13.8302 18.3891 13.7513 18.1984 13.7513 17.9997C13.7513 17.8009 13.8302 17.6103 13.9707 17.4697L18.6907 12.7497L4.50066 12.7497C4.30175 12.7497 4.11098 12.6707 3.97033 12.53C3.82968 12.3894 3.75066 12.1986 3.75066 11.9997C3.75066 11.8008 3.82968 11.61 3.97033 11.4694C4.11098 11.3287 4.30175 11.2497 4.50066 11.2497L18.6907 11.2497L13.9707 6.52968C13.897 6.46102 13.8379 6.37822 13.7969 6.28622C13.7559 6.19422 13.7338 6.09491 13.7321 5.9942C13.7303 5.8935 13.7488 5.79347 13.7865 5.70009C13.8243 5.6067 13.8804 5.52186 13.9516 5.45064C14.0228 5.37943 14.1077 5.32328 14.2011 5.28556C14.2945 5.24784 14.3945 5.22932 14.4952 5.23109C14.5959 5.23287 14.6952 5.25491 14.7872 5.2959C14.8792 5.33689 14.962 5.396 15.0307 5.46968L21.0307 11.4697C21.1711 11.6103 21.25 11.8009 21.25 11.9997C21.25 12.1984 21.1711 12.3891 21.0307 12.5297L15.0307 18.5297C14.89 18.6701 14.6994 18.749 14.5007 18.749C14.3019 18.749 14.1113 18.6701 13.9707 18.5297Z"
      fill="currentColor" />
  </svg>
`

const imageCover = `
  <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="32px" width="32px" xmlns="http://www.w3.org/2000/svg">
    <rect width="416" height="352" x="48" y="80" fill="none" stroke-linejoin="round" stroke-width="32" rx="48" ry="48"></rect>
    <circle cx="336" cy="176" r="32" fill="none" stroke-miterlimit="10" stroke-width="32"></circle>
    <path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="m304 335.79-90.66-90.49a32 32 0 0 0-43.87-1.3L48 352m176 80 123.34-123.34a32 32 0 0 1 43.11-2L464 368">
    </path>
  </svg>
`


function getStatusValue(key) {
  const lang = document.documentElement.getAttribute('lang') || 'ja';
  const statusMap = {
    "en": {
      "0": "Not Activated",
      "1": "Activated",
      "2": "Expired",
      "3": "Data Limit Reached",
      "4": "Reserved",
    },
    "ja": {
      "0": "未アクティブ",
      "1": "アクティブ済",
      "2": "期限切れ",
      "3": "容量切れ",
      "4": "予約済",
    }
  };
  const targetLangMap = statusMap[lang] || statusMap.ja; 
  if (key == null || key === "") {
    return "";
  }
  key = String(key);
  return targetLangMap[key] ?? "";
}

function getBackground(esimStatus) {
  switch (esimStatus) {
    case "3": return "#DD2F2C";    // 红色
    case "1": return "#FFB61D";    // 橙色
    case "2": return "#EF9C11";    // 深橙色
    case "0":
    case "4":
    default:  return "rgba(151, 160, 178, 0.17)"; // 默认灰色
  }
}

function renderUpdateTime() {
  const update_time = document.querySelector('.update-time');
  const now = new Date();
  update_time.innerText = `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()} 02:00:38`;
}

function refreshClick(activationCode) {
  return new Promise((resolve, reject) => {
    fetch(`https://shopifyrecharge.desim.tech/cms-api/open/lineController/getESIMInfoByActivationCode?activationCode=${activationCode}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(res => {
        if (res.code === 200) {
          resolve()
        } else {
          reject(new Error(`API error! code: ${res.code}, msg: ${res.msg}`));
        }
      })
      .catch((e) => {
        reject(e)
      })
  })
}